export const ProjectIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 14L1 20.5H23L19 14H5Z"
        stroke="white"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 10L17.5 16.5"
        stroke="white"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 10L6.5 16.5"
        stroke="white"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3354 8.48582C20.2437 9.79989 18.3838 9.98999 17.5 10V9.43635C17.5289 8.31573 17.7368 6.61812 18.6581 5.51417C19.7498 4.20011 21.6127 4.01001 22.4964 4C22.5224 5.01723 22.4329 7.16843 21.3354 8.48582Z"
        stroke="white"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      <path
        d="M10.3354 8.48582C9.2437 9.79989 7.38376 9.98999 6.5 10V9.43635C6.52888 8.31573 6.73682 6.61812 7.65813 5.51417C8.74983 4.20011 10.6127 4.01001 11.4964 4C11.5224 5.01723 11.4329 7.16843 10.3354 8.48582Z"
        stroke="white"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      <path
        d="M16.2382 8.93168C17.3332 9.80504 17.4917 11.293 17.5 12L17.0303 12C16.0964 11.9769 14.6818 11.8105 13.7618 11.0735C12.6668 10.2001 12.5083 8.70987 12.5 8.00286C13.3477 7.98207 15.1404 8.05369 16.2382 8.93168Z"
        stroke="white"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      <path
        d="M5.23819 8.93168C6.33324 9.80504 6.49166 11.293 6.5 12L6.03029 12C5.09644 11.9769 3.68177 11.8105 2.76181 11.0735C1.66676 10.2001 1.50834 8.70987 1.5 8.00286C2.34769 7.98207 4.14036 8.05369 5.23819 8.93168Z"
        stroke="white"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
    </svg>
  );
};
